import { render, staticRenderFns } from "./TurnProductivityEuropa.vue?vue&type=template&id=812c5ea4"
import script from "./TurnProductivityEuropa.vue?vue&type=script&lang=js"
export * from "./TurnProductivityEuropa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports